<template>
    <div class="modal-title">
    <h2>{{ dataDictionary.title }}</h2>
    </div>
    <div class="call-content">
        <a
            :href="`tel:${dataDictionary.number}`"
            class="call-button"
            aria-label="Call"
        >
            Place a call
        </a>
    </div>

</template>
<script>
    export default{
        name: "PhoneChild",
        props: {
            dataDictionary: {
                required: true,
            type: Object,
            },
        }
    }
</script>
